import { render, staticRenderFns } from "./ClosureDetails.vue?vue&type=template&id=1f04e477"
import script from "./ClosureDetails.vue?vue&type=script&lang=js"
export * from "./ClosureDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports